export const Colors = {
    HEAD_BACKGROUND_COLOR: 'white',
    BACKGROUND_COLOR: '#f9f9f9',
    MOBILE_MENU_TITLE: '#757575',
    MOBILE_MENU_SEPARATOR: '#DDDDDD',
    INDEX_PAGE_BACKGROUND: '#F4E800',
    DONATE_PAGE_BACKGROUND: '#CEFFA5',
    NICHE_PINK: '#FF9E9E',
    NICHE_BLACK: '#212121',
    NICHE_GREEN: '#34DFB6',
    NICHE_BLUE: '#141033',
    SUBSCRIBE_FOOTER_BACKGROUND_COLOR: 'black',
}

export const CONTENT_MAX_WIDTH = 1160
export const WIDTH_THRESHOLD = 992

export const PADDING_CSS_EXPRESSION = '1.4rem + 5.4vmin'
export const VERTICAL_PADDING = `calc(${PADDING_CSS_EXPRESSION})`
export const VERTICAL_HALF_PADDING = `calc((${PADDING_CSS_EXPRESSION}) / 2)`
export const NICHE_VERTICAL_PADDING = `calc((${PADDING_CSS_EXPRESSION}) * 1.5)`
export const MIN_SECTION_PADDING = 20

export const QUERY_FOR_MOBILE_AND_TABLET = `(max-width: ${WIDTH_THRESHOLD}px)`

export const FONT_SIZE_D24_M14 = 'calc(0.96rem + 0.80vmin)'
export const FONT_SIZE_D24_M16 = 'calc(0.78rem + 1.10vmin)'
export const FONT_SIZE_D18_M16 = 'calc(0.95rem + 0.26vmin)'
export const FONT_SIZE_D18_M14 = 'calc(0.77rem + 0.53vmin)'
export const FONT_SIZE_D18_M12 = 'calc(0.59rem + 0.80vmin)'
export const FONT_SIZE_D14_M12 = 'calc(0.67rem + 0.53vmin)'
export const FONT_SIZE_D14_M10 = 'calc(0.52rem + 0.53vmin)'
